<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col v-if="show && valueComputed?.sectionColor" class="mb-0 px-2 pt-2" cols="12" >
          <colors-component v-model="valueComputed.sectionColor" />
        </v-col>
        <v-col v-if="!justColor" class="px-2 pt-2" cols>
          <v-switch
            v-if="
              both &&
              ![
                'qr.catalog',
                'qr.name.editCatalog',
                'qr.name.id.editCatalog',
              ].includes($route.name)
            "
            v-model="valueComputed.slider"
            class="mt-0"
            :label="$t('show_as_slider')"
          />
          <v-switch
            v-if="beGrid"
            v-model="valueComputed.grid"
            class="mt-0"
            :label="$t('show_as_grid')"
          />
          <v-switch
            v-if="secondPosition"
            v-model="valueComputed.secondPosition"
            class="mt-0"
            :label="$t('show_as_second_mode')"
          />
          <v-row no-gutters>
            <v-col cols="12" md="6">
              <div class="rowinfo">
                <v-text-field
                  v-model="valueComputed.title"
                  append-icon="mdi-pencil"
                  class="mx-1"
                  clearable
                  dense
                  :label="$t('title')"
                  outlined
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-valueComputed-title`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('title')"
                />
              </div>
            </v-col>
            <v-col cols="12">
              <div class="rowinfo">
                <v-textarea
                  v-model="valueComputed.description"
                  append-icon="mdi-pencil"
                  class="mx-1"
                  hide-details
                  clearable
                  dense
                  :label="$t('description')"
                  outlined
                  rows="5"
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-valueComputed-description`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('description')"
                />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import ColorsComponent from "../colorsComponent";
import HelpInfo from "../../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../../qrland/components/helpAcordion/HelpInfoWrapper.vue";

export default {
  name: "galleriesTexts",

  components: { ColorsComponent, HelpInfo, HelpInfoWrapper },

  props: {
    value: Object,
    both: Boolean,
    beGrid: Boolean,
    justColor: Boolean,
    secondPosition: Boolean,
    show: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "galleriesTexts-B",
    };
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    data() {
      return {
        title: this.$t("title"),
        description: this.$t("description"),
        slider: false,
        grid: true,
        sectionColor: {},
      };
    },
    valueComputed: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
